import { Component } from '@angular/core';

@Component({
  selector: 'kpis-zero-state',
  templateUrl: './kpis-zero-state.component.html',
  styleUrl: './kpis-zero-state.component.scss'
})
export class KpisZeroStateComponent {}
